import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import TaskReportPage from './TaskReportPage';
import TaskReportsPage from './TaskReportsPage';
import TaskReportNew from './TaskReportNew';
import TaskReportEdit from './TaskReportEdit';
import IssuesPage from './IssuesPage';
import IssuePage from './IssuePage';
import IssueNew from './IssueNew';

const Review = ({ match }) => (
   <Switch>
      <Route path={`${match.url}/tasks/edit/:id`} component={TaskReportEdit} />
      <Route path={`${match.url}/tasks/new`} component={TaskReportNew} />
      <Route path={`${match.url}/tasks/:id`} component={TaskReportPage} />
      <Route path={`${match.url}/task-reports`} component={TaskReportsPage} />
      <Route path={`${match.url}/issues/new`} component={IssueNew} />
      <Route path={`${match.url}/issues/:noIssue`} component={IssuePage} />
      <Route exact path={`${match.url}/issues`} component={IssuesPage} />
      <Redirect exact from={`${match.url}/`} to={`${match.url}/task-reports`} />
   </Switch>
);

export default Review;
